import React, { useEffect } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import styles from "./CoffeeOfTheWeekPage.module.css";

// --- IMAGES ---
import heroBg from "../assets/coffee-of-the-week/1.jpg"; // Assuming this is correct (no error reported)

// FIX 1: Error said disk has '2.JPG'
import archersLogo from "../assets/coffee-of-the-week/2.JPG";

// FIX 2: Error said disk has '3.jpg'
import coffeeBag from "../assets/coffee-of-the-week/3.jpg";

function CoffeeOfTheWeekPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.cotwPage}>
      <Navbar />

      {/* 1. HERO SECTION (Image 1) */}
      <section
        className={styles.heroSection}
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className={styles.heroOverlay}></div>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>COFFEE OF THE WEEK</h1>
          <h2 className={styles.heroSubtitle}>What’s Coffee of the Week?</h2>
          <p className={styles.heroText}>
            Every week we highlight roasters who bring global flavors to your
            cup. The origin of the coffee could be Ethiopia, Colombia, Kenya,
            Rwanda, Panama and beyond. These Roasters buy their green bean from
            Ethiopia through Daye Bensa. We want you to broaden your palate and
            enjoy a truly global coffee experience.
          </p>
        </div>
      </section>

      {/* 2. LOGO BANNER (Image 2) */}
      <section className={styles.logoBanner}>
        <img
          src={archersLogo}
          alt="Archers Logo"
          className={styles.logoImage}
        />
      </section>

      {/* 3. MAIN CONTENT */}
      <div className={styles.contentContainer}>
        {/* Roaster Info */}
        <div className={styles.roasterInfo}>
          <p>Roaster: Archers</p>
          <p>Location: Sharjah, UAE</p>
          <p>IG: @archers.ae</p>
        </div>

        {/* Quality Story */}
        <div className={styles.storySection}>
          <h3 className={styles.storyTitle}>
            QUALITY. TRANSPARENCY. SUSTAINABILITY.
          </h3>
          <p className={styles.storyText}>
            This week we are featuring some of our good friends coffee all the
            way from UAE. Archers is a Green Coffee Trader, Roastery, and
            certified SCA and CQI Coffee Academy. Their mission is to
            continually meet the evolving needs of our customers and colleagues
            — at all levels — and contribute to advancing our industry and
            enriching our community.
          </p>
        </div>

        {/* Product Image (Image 3) */}
        <div className={styles.productImageContainer}>
          <img
            src={coffeeBag}
            alt="Panama Iris Estate Symmetry"
            className={styles.productImage}
          />
        </div>

        <p className={styles.availabilityText}>
          One of these coffees will be available. Ask your server or barista for
          more info
        </p>

        {/* Coffee List */}
        <div className={styles.coffeeList}>
          {/* Coffee 1 */}
          <div className={styles.coffeeItem}>
            <h2>Panama Iris Estate Symmetry</h2>
            <ul className={styles.coffeeDetails}>
              <li>
                <span className={styles.label}>Origin:</span> Panama: Volcan,
                Chiriqui
              </li>
              <li>
                <span className={styles.label}>Farmers/Producers:</span> Jamison
                Savage
              </li>
              <li>
                <span className={styles.label}>Process:</span> Natural Carbonic
                Maceration
              </li>
              <li>
                <span className={styles.label}>Flavor Notes:</span> White
                grapes, tropical fruit, mandarine, raspberry candy
              </li>
            </ul>
          </div>

          {/* Coffee 2 */}
          <div className={styles.coffeeItem}>
            <h2>Yemen Yahya Al-Maznai Mazana'a Village</h2>
            <ul className={styles.coffeeDetails}>
              <li>
                <span className={styles.label}>Origin:</span> Yemen: Mazana'a
                Village, West Haraz
              </li>
              <li>
                <span className={styles.label}>Farm/Producer from:</span> Yahya
                Al-Maznai
              </li>
              <li>
                <span className={styles.label}>Process:</span> Natural anaerobic
              </li>
              <li>
                <span className={styles.label}>Flavor Notes:</span> Raisins,
                mango, cherry, purple grapes
              </li>
            </ul>
          </div>

          {/* Coffee 3 */}
          <div className={styles.coffeeItem}>
            <h2>El Salvador Finca El Cerro Pacamara</h2>
            <ul className={styles.coffeeDetails}>
              <li>
                <span className={styles.label}>Origin:</span> El Salvador:
                Apaneca, Ahuachapan
              </li>
              <li>
                <span className={styles.label}>Farm/Producer:</span> Fernando
                Escobar
              </li>
              <li>
                <span className={styles.label}>Process:</span> Natural Anaerobic
              </li>
              <li>
                <span className={styles.label}>Flavor Notes:</span> Red apple,
                apricot, dark honey, chocolate brownie
              </li>
            </ul>
          </div>

          {/* Coffee 4 */}
          <div className={styles.coffeeItem}>
            <h2>Kenya Gakuyuini AA Washed</h2>
            <ul className={styles.coffeeDetails}>
              <li>
                <span className={styles.label}>Origin:</span> Kenya: Kirinyaga
              </li>
              <li>
                <span className={styles.label}>Farmers/Producers from:</span>{" "}
                Thirikwa Farmers Cooperative Society
              </li>
              <li>
                <span className={styles.label}>Process:</span> Washed
              </li>
              <li>
                <span className={styles.label}>Flavor Notes:</span> Black
                currant, cane sugar, oolong tea, caramel
              </li>
            </ul>
          </div>
        </div>

        {/* Special Info */}
        <div className={styles.specialSection}>
          <p>
            Why It's Special: Archers hold a special place in our hearts. They
            are more than just roasters and green bean traders; they are true
            innovators who drive the coffee industry forward. Their support has
            been instrumental in helping us at Dukamo, Daye Bensa, Sidama,
            Ethiopia, as we strive to produce and brew exceptional coffees. We
            deeply appreciate their dedication and commitment, and we are
            grateful to call them our friends.
          </p>

          <div className={styles.moreInfo}>
            For more info, check their website:
            <a
              href="https://archerscoffee.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://archerscoffee.com/
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default CoffeeOfTheWeekPage;
